<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><a id="ad_card_1"></a><p class="ach"><span class="small">ALSO BY LORI LANSENS</span></p><p class="acl"><em>Rush Home Road</em></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Girls_ad_card_1.vue?25281a23